export const EVENTS = {
    CONNECT: "connect",
    DISCONNECT: "disconnect",

    CONNECT_ERROR: "connect_error",
    ERROR: "error",

    JOIN_BLUEPRINT: "join-blueprint",
    LEAVE_BLUEPRINT: "leave-blueprint",

    VALIDATOR_LOG: "validator-log",
    RUNTIME_LOG: "runtime-log",
    SIMULATION_LOG: "simulation-log",

    UPDATE_LOG_MAP: "update-log-map",
    RESET_POLL_TIMER: "reset-poll-timer",

    SIMULATION_STOPPED: "simulation-stopped",

    UPDATE_LOG_FILTER: "update-log-filter"
};